import { useState } from 'react';
import { useGlobal } from '@/utils/useGlobal';
import { ProductSubType } from '../type';

const ICON_1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
        <g className="svg-g">
            <rect width="100%" height="100%" rx="12" fill="#38383D" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.24129 12.545H15.7516C15.9291 12.545 16.0749 12.4939 16.1889 12.3916C16.303 12.2893 16.3601 12.1586 16.3601 11.9996C16.3601 11.8405 16.303 11.7098 16.1889 11.6075C16.0749 11.5052 15.9291 11.4541 15.7516 11.4541H8.24129C8.06381 11.4541 7.91804 11.5052 7.80395 11.6075C7.68986 11.7098 7.63281 11.8405 7.63281 11.9996C7.63281 12.1586 7.68986 12.2893 7.80395 12.3916C7.91804 12.4939 8.06381 12.545 8.24129 12.545Z"
                fill="#E6E6E6"
            />
        </g>
    </svg>
);

const ICON_2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
        <g className="svg-g">
            <rect width="100%" height="100%" rx="12" fill="#38383D" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.24129 12.6088H11.388V15.7555C11.388 15.933 11.445 16.0788 11.5591 16.1929C11.6732 16.3069 11.819 16.364 11.9964 16.364C12.1739 16.364 12.3197 16.3069 12.4338 16.1929C12.5479 16.0788 12.6049 15.933 12.6049 15.7555V12.6088H15.7516C15.9291 12.6088 16.0749 12.5518 16.1889 12.4377C16.303 12.3236 16.3601 12.1778 16.3601 12.0004C16.3601 11.8229 16.303 11.6771 16.1889 11.563C16.0749 11.4489 15.9291 11.3919 15.7516 11.3919H12.6049V8.24519C12.6049 8.06772 12.5479 7.92194 12.4338 7.80785C12.3197 7.69376 12.1739 7.63672 11.9964 7.63672C11.819 7.63672 11.6732 7.69376 11.5591 7.80785C11.445 7.92194 11.388 8.06772 11.388 8.24519V11.3919H8.24129C8.06381 11.3919 7.91804 11.4489 7.80395 11.563C7.68986 11.6771 7.63281 11.8229 7.63281 12.0004C7.63281 12.1778 7.68986 12.3236 7.80395 12.4377C7.91804 12.5518 8.06381 12.6088 8.24129 12.6088Z"
                fill="#E6E6E6"
            />
        </g>
    </svg>
);

interface AddReduceCalcProps {
    data: ProductSubType;
    callback: (data: ProductSubType, num: number) => void;
}

const AddReduceCalc = ({ data, callback }: AddReduceCalcProps) => {
    const { gtm } = useGlobal();

    const NUM_MIN = data?.min || 0;
    const NUM_MAX = ((data?.inventory ?? 0) > 0 ? data?.inventory : 0) as number;
    const [number, setNumber] = useState(data?.quantity ?? 0);

    const reduceNumber = () => {
        if (number <= NUM_MIN) return false;
        setNumber(number - 1);
        callback(data, number - 1);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_remove_from_cart',
                product_name: data?.name,
                price: data?.discountPrice,
                quantity: number - 1,
                button_name: '-',
                list_name: 'none',
                tag: 'none',
            });
        } catch (e) {
            console.error(e);
        }
    };

    const addNumber = () => {
        if (number >= NUM_MAX) {
            return false;
        }
        setNumber(number + 1);
        callback(data, number + 1);
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                product_name: data?.name,
                price: data?.discountPrice,
                quantity: number + 1,
                button_name: '+',
                list_name: 'none',
                tag: 'none',
            });
        } catch (e) {
            console.error(e);
        }
    };

    const inputChange = (e: any) => {
        const v = e.target.value.replace(/[^0-9]/g, '');
        if (v < NUM_MIN || v > NUM_MAX) {
            return;
        }
        setNumber(Number(v));
        callback(data, Number(v));
    };

    return (
        <div className="bundle-calculator">
            <div className={number <= NUM_MIN ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                <ICON_1 />
            </div>
            <input className="addSubtractor-number" value={number} onChange={inputChange} />
            <div className={number >= NUM_MAX ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={addNumber}>
                <ICON_2 />
            </div>
        </div>
    );
};

export default AddReduceCalc;
